
import GoogleAnalytics from "./components/GA";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ThemeWrapper from "./components/ThemeWrapper";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/Footer";

import MainLayout from "./layouts/MainLayout"; // ✅ MISSING IMPORT

// Pages
import Home from "./pages/HomePage";
import ArticlePage from "./pages/ArticlePage";
import CategoryPage from "./pages/CategoryPage";
import Search from "./pages/Search";
import Login from "./pages/Login";
import CreateArticle from "./pages/dashboard/CreateArticle";
import ScrollToTop from "./components/ScrollToTop";
import ArticleList from "./pages/dashboard/ArticleList";
import EditArticle
  from "./pages/dashboard/EditArticle";
import ArticlePreview from "./pages/ArticlePreview";
import Contact from "./pages/Contact";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import TagPage from "./pages/TagPage";
import AuthorProfile from "./pages/AuthorProfile";

export default function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics /> {/* ✅ load GA once */}
      <ThemeWrapper>
        <ScrollToTop />
        <MainLayout />
        <Routes>
          {/* 🌐 PUBLIC SITE (WITH NAVBAR) */}
          <Route path="/" element={<Home />} />
          <Route path="/article/:slug" element={<ArticlePage />} />
          <Route path="/category/:cat" element={<CategoryPage />} />
          <Route path="/search" element={<Search />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/tag/:tag" element={<TagPage />} />
          <Route path="/author/naveen-kumar" element={<AuthorProfile />} />

          {/* 🔐 AUTH / ADMIN (NO NAVBAR) */}
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard/articles" element={<ProtectedRoute>
            <ArticleList />
          </ProtectedRoute>
          } />
          <Route path="/dashboard/articles/create" element={<ProtectedRoute>
            <CreateArticle />
          </ProtectedRoute>} />
          <Route path="/dashboard/articles/edit/:slug" element={<ProtectedRoute>
            <EditArticle />
          </ProtectedRoute>
          } />

          <Route path="/article/preview" element={<ProtectedRoute>
            <ArticlePreview />
          </ProtectedRoute>
          } />


        </Routes>

        {/* ✅ Footer only for public pages */}
        <Footer />

      </ThemeWrapper>
    </BrowserRouter >
  );
}
